import React from "react"
import {
  listAddressesContainer,
  listAddressesTitle,
  addressesContainer,
  addressesDescription,
  allAddresses,
  editButtonTitle,
} from "./carnet-adresse.module.scss"
import { Container, Title } from "./carnet-adresse-styled"
import ContentTransformer from "../../Transformers/content-transformer"
import TransitionFade from "../../transition-fade"
import RenderAddresses from "./RenderAddresses/render-addresses"
import { useCarnetAdresse } from "./carnet-adresse-query"
import EditButton from "../../EditButton/edit-button"

//-----------------------Parent component---------------------------//

const CarnetAdresse = () => {
  const data = useCarnetAdresse()
  if (data.allNodeCarnetDAdresse.edges.length === 0) {
    return null
  }
  return (
    <Container className={listAddressesContainer}>
      <div>
        <Title className={listAddressesTitle}>
          <EditButton
            addedClass={editButtonTitle}
            link={
              "/taxonomy/term/" +
              data.taxonomyTermZoneDefinie.drupal_internal__tid +
              "/edit"
            }
          />
          {data.taxonomyTermZoneDefinie?.field_label || "Carnet d'addresses"}
        </Title>
        <div className={allAddresses}>
          <TransitionFade className="btn" link="/adresses">
            Voir le carnet complet
          </TransitionFade>
        </div>
      </div>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={addressesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={addressesContainer} role={"list"}>
        <RenderAddresses addressesData={data} />
      </div>
    </Container>
  )
}

//-----------------------Parent component---------------------------//

export default CarnetAdresse
